<div class="web-view">

  <div class="main-div" fxLayout="row wrap">
    <div class="bodyClass">

      <div class="headers">
        <a href="/userProfiles/{{userId}}/setup/1"> <img src="assets\images\orange image.png" class="backArrow"></a>

        <h1 class="heading1">Share Your Interests </h1>
        <a href="/userProfiles/{{userId}}/setup/3"  class="skip"> <button class="skipbtn" style="padding:1% 5%"
           appTrackClick
          [buttonProps]="{
              title:'setup_two_skip_button',
              feature_context:'ONBOARDING'
          }"
          >Skip</button></a>
        <hr>
      </div>
      <div class="container">
        <h1 class="heading2">I'm a Fan of</h1>

        <p class="textClass">"What Makes you Fan-tastic?" - Choose upto 3 of your favorite areas!</p>


        <ng-container *ngFor="let toggleObj of toggleDataFan">
          <label class="switch">
              <input type="checkbox" [name]="toggleObj.name" (change)="onToggleChange()"
                  [(ngModel)]="toggleObj.ischecked" [disabled]="toggleObj.isDisabled" #fan3   
                  appTrackClick
                [buttonProps]="{
                    title:'setup_two_im_fan_option_selected',
                    customeId:toggleObj.name,
                    feature_context:'ONBOARDING'
                }">
              <span class="slider round">{{toggleObj.name}}</span>
          </label>
      </ng-container>
 </div>
      <hr>

      <h1 class="heading2">I'm a Creator of</h1>

      <p class="textClass"> Choose upto 3 of your professional or aspiring areas!</p>

      <ng-container *ngFor="let toggleObj1 of toggleDataCreator">
        <label class="switch">
          <input type="checkbox" [name]="toggleObj1.name" (change)="onToggleChange1();" [(ngModel)]="toggleObj1.ischecked" [disabled]="toggleObj1.isDisabled" #fan3
           appTrackClick
                [buttonProps]="{
                    title:'setup_two_im_creator_option_selected',
                    customeId:toggleObj1.name,
                    feature_context:'ONBOARDING'
                }"
          >
          <span class="slider1 round">{{toggleObj1.name}}</span>
        </label>
    </ng-container>
      <!-- <div class="container">
        <label class="switch">
          <input type="checkbox" name="Art & Design C1" (change)="checkCheckBoxvalue($event)" [(ngModel)]="isChecked10"
            #creater1>
          <span class="slider1 round">Art & Design</span>
        </label>
        <label class="switch">
          <input type="checkbox" name=" Books & Storytelling C2" (change)="checkCheckBoxvalue($event)"
            [(ngModel)]="isChecked11" #creater2>
          <span class="slider1 round">Books & Storytelling</span>
        </label>
        <label class="switch">
          <input type="checkbox" name="Dance C3" (change)="checkCheckBoxvalue($event)" [(ngModel)]="isChecked12"
            #creater3>
          <span class="slider1 round">Dance</span>
        </label>
        <label class="switch">
          <input type="checkbox" name="Fashion C4" (change)="checkCheckBoxvalue($event)" [(ngModel)]="isChecked13"
            #creater4>
          <span class="slider1 round">Fashion</span>
        </label>
        <label class="switch">
          <input type="checkbox" name="Film C5" (change)="checkCheckBoxvalue($event)" [(ngModel)]="isChecked14"
            #creater5>
          <span class="slider1 round">Film</span>
        </label>
        <label class="switch">
          <input type="checkbox" name="Music C6" (change)="checkCheckBoxvalue($event)" [(ngModel)]="isChecked15"
            #creater6>
          <span class="slider1 round">Music</span>
        </label>
        <label class="switch">
          <input type="checkbox" name=" Tech & Science C7" (change)="checkCheckBoxvalue($event)"
            [(ngModel)]="isChecked16" #creater7>
          <span class="slider1 round">Tech & Science</span>
        </label>
        <label class="switch">
          <input type="checkbox" name="Television C8" (change)="checkCheckBoxvalue($event)" [(ngModel)]="isChecked17"
            #creater8>
          <span class="slider1 round">Television</span>
        </label>
        <label class="switch">
          <input type="checkbox" name="Virtual Reality C9" (change)="checkCheckBoxvalue($event)"
            [(ngModel)]="isChecked18" #creater9>
          <span class="slider1 round">Virtual Reality</span>
        </label>

      </div> -->
      <hr>

      <button class="submitbtn"
        [ngStyle]="(submitButtonEnabled) ?   {'cursor' :'pointer','opacity':'1'}:{'cursor': 'not-allowed','opacity':'0.65'}"
        [disabled]="!submitButtonEnabled"
        (click)="submit()"
          appTrackClick
          [buttonProps]="{
              title:'setup_two_submit_button',
              feature_context:'ONBOARDING'
          }"
        >Submit</button>
    </div>
  </div>

</div>